import { UTMPlaceholders } from '../constants/place-holders';

// Adds the start/ending tokens to the string if its matches a UTM Keyword
export const addTokenCharsToUTMField = (value: string): string => {
  const words = value.split(' ');

  UTMPlaceholders.forEach(p => {
    const index = words.findIndex(w => w === p);

    if (index > -1) {
      words[index] = `_${words[index]}_`;
    }
  });

  return words.join(' ');
};

// Removes the start/ending tokens for a string that matches the list of UTM Keywords
export const removeTokenCharsFromUTMField = (value: string): string => {
  const words = value.split(' ');

  UTMPlaceholders.forEach(p => {
    const index = words.findIndex(w => w === `_${p}_`);

    if (index > -1) {
      words[index] = p;
    }
  });

  return words.join(' ');
};
